import { render, staticRenderFns } from "./Countries.vue?vue&type=template&id=13c3dbc6&scoped=true"
import script from "./Countries.vue?vue&type=script&lang=js"
export * from "./Countries.vue?vue&type=script&lang=js"
import style0 from "./Countries.scss?vue&type=style&index=0&id=13c3dbc6&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c3dbc6",
  null
  
)

export default component.exports